import React from 'react';

function App() {
  const value = 'World';
  return <div>Hello {value} Dino YES!!!!</div>;
}

export default App;
